const initialTeamLastActivity = {
    team_last_activity: [],
    updated_team_last_activity: true,
};

export default initialTeamLastActivity;